export const BASE_URL = 'v1/abandoned-carts';

export const ABANDONED_CARTS_DETAILS_URL = `${BASE_URL}/:id`;
export const ABANDONED_CARTS_EMAIL_CONFIG_URL = `${BASE_URL}/email/config`;
export const ABANDONED_CARTS_SEND_EMAIL_URL = `${BASE_URL}/send-email/:id`;
